import { Store } from '@souche-f2e/muji';

const modules = {
  'debug': require('../stores/debug.js').default,
  'docs': require('../stores/docs.js').default,
  'documents': require('../stores/documents.js').default,
  'faq': require('../stores/faq.js').default,
  'global': require('../stores/global.js').default,
  'notices': require('../stores/notices.js').default,
  'order': require('../stores/order.js').default,
  'pdf': require('../stores/pdf.js').default,
  'setting': require('../stores/setting.js').default,
  'sider': require('../stores/sider.js').default,
  'stabledocs': require('../stores/stabledocs.js').default,
  'stablesider': require('../stores/stablesider.js').default,
  'traffic': require('../stores/traffic.js').default,
  'user': require('../stores/user.js').default
};

const storeConfig = {
  initialState: window['@@muji@StoreInitialState'] || {},
  modules,
}

const store = new Store(storeConfig);

export default store;
export const { dispatch, getState } = store;

if (module.hot) {
  // save current state before module being reloaded
  module.hot.dispose(() => window['@@muji@StoreInitialState'] = store.getState());
  
  module.hot.accept(['../stores/debug.js'], () => {
    store.mount('debug', require('../stores/debug.js').default);
  });
  
  module.hot.accept(['../stores/docs.js'], () => {
    store.mount('docs', require('../stores/docs.js').default);
  });
  
  module.hot.accept(['../stores/documents.js'], () => {
    store.mount('documents', require('../stores/documents.js').default);
  });
  
  module.hot.accept(['../stores/faq.js'], () => {
    store.mount('faq', require('../stores/faq.js').default);
  });
  
  module.hot.accept(['../stores/global.js'], () => {
    store.mount('global', require('../stores/global.js').default);
  });
  
  module.hot.accept(['../stores/notices.js'], () => {
    store.mount('notices', require('../stores/notices.js').default);
  });
  
  module.hot.accept(['../stores/order.js'], () => {
    store.mount('order', require('../stores/order.js').default);
  });
  
  module.hot.accept(['../stores/pdf.js'], () => {
    store.mount('pdf', require('../stores/pdf.js').default);
  });
  
  module.hot.accept(['../stores/setting.js'], () => {
    store.mount('setting', require('../stores/setting.js').default);
  });
  
  module.hot.accept(['../stores/sider.js'], () => {
    store.mount('sider', require('../stores/sider.js').default);
  });
  
  module.hot.accept(['../stores/stabledocs.js'], () => {
    store.mount('stabledocs', require('../stores/stabledocs.js').default);
  });
  
  module.hot.accept(['../stores/stablesider.js'], () => {
    store.mount('stablesider', require('../stores/stablesider.js').default);
  });
  
  module.hot.accept(['../stores/traffic.js'], () => {
    store.mount('traffic', require('../stores/traffic.js').default);
  });
  
  module.hot.accept(['../stores/user.js'], () => {
    store.mount('user', require('../stores/user.js').default);
  });
}
